import { render, staticRenderFns } from "./CategoryPageContentFilter.vue?vue&type=template&id=051a6fbc&scoped=true&"
import script from "./CategoryPageContentFilter.vue?vue&type=script&lang=js&"
export * from "./CategoryPageContentFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPageContentFilter.vue?vue&type=style&index=0&id=051a6fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a6fbc",
  null
  
)

export default component.exports